import type { PlanId } from '../types';

/**
 * Computes the CSS translateX offset for each carousel tab based on viewport width.
 *
 * Layout rule (cardWidth = viewportWidth - 56px):
 *   Tab 0 (Free):   16          → 16px left margin; Identity Plus peeks 24px on the right
 *   Tab 1 (ID+):    68 - W      → Free & CreditExpert each peek 12px
 *   Tab 2 (CE):     120 - 2W   → Identity Plus peeks 24px; 16px right margin
 */
export const computeTrackOffsets = (viewportWidth: number): [number, number, number] => [
  16,
  68 - viewportWidth,
  120 - 2 * viewportWidth,
];

// Matches the card + current-account height the user must scroll past before
// the compact sticky header takes over (see CarouselViewport scroll handler).
export const STICKY_HEADER_SCROLL_THRESHOLD_PX = 200;

export const SEGMENTED_COLORS: Record<PlanId, { track: string; activeItem: string }> = {
  basic: { track: '#5E6976', activeItem: '#F8F8F9' },
  identity: { track: '#4A154B', activeItem: '#EEE0ED' },
  credit_expert: { track: '#1A2B4B', activeItem: '#E1E4EF' },
};
